import { NAME } from "./constants";

const select = key => state => state.pages[NAME][key];

export const isLoading = select("isLoading");
export const getCustomerDetails = state => {
    return state.pages.customerView.customer
};